import React from 'react';
import { Tooltip } from 'antd';
import { ReactComponent as SmartphoneIcon } from '../../../../resource/SmartphoneIcon.svg';
import { ReactComponent as NotMobileIcon } from '../../../../resource/NotMobileIcon.svg';

const MobileApplication = ({ hasMobileApplication }) => {
  return (
    <Tooltip
      title={hasMobileApplication ? 'Есть приложение' : 'Нет приложения'}
    >
      {hasMobileApplication ? <SmartphoneIcon /> : <NotMobileIcon />}
    </Tooltip>
  );
};

export default MobileApplication;
